import api from './api';

export const authService = {
  async sendVerificationCode(email, username, captchaVerifyParam) {
    const response = await api.post('/auth/send-code', { email, username, captchaVerifyParam });
    return response.data;
  },

  async register(username, email, password, verificationCode) {
    const response = await api.post('/auth/register', { username, email, password, verificationCode });
    return response.data;
  },

  async login(email, password, captchaVerifyParam) {
    const response = await api.post('/auth/login', { email, password, captchaVerifyParam });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  async getProfile() {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  async getAllUsers(page = 1, limit = 10, search = '') {
    const response = await api.get('/auth/users', {
      params: { page, limit, search }
    });
    return response.data;
  },

  async updateUserRole(userId, role) {
    const response = await api.put(`/auth/users/${userId}/role`, { role });
    return response.data;
  },

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated() {
    return !!localStorage.getItem('token');
  }
};

export const settingsService = {
  async getRegistrationStatus() {
    const response = await api.get('/settings/registration');
    return response.data;
  },

  async updateRegistrationStatus(isOpen) {
    const response = await api.put('/settings/registration', { isOpen });
    return response.data;
  },

  async getCaptchaConfig() {
    const response = await api.get('/settings/captcha');
    return response.data;
  }
};

export const playlistService = {
  async getAllPlaylists() {
    const response = await api.get('/playlists');
    return response.data;
  },

  async getPlaylistById(id) {
    const response = await api.get(`/playlists/${id}`);
    return response.data;
  },

  async createPlaylist(data) {
    const response = await api.post('/playlists', data);
    return response.data;
  },

  async addSong(playlistId, songData) {
    const response = await api.post(`/playlists/${playlistId}/songs`, songData);
    return response.data;
  },

  async batchAddSongs(playlistId, songs) {
    const response = await api.post(`/playlists/${playlistId}/songs/batch`, { songs });
    return response.data;
  },

  async updateSong(songId, songData) {
    const response = await api.put(`/playlists/songs/${songId}`, songData);
    return response.data;
  },

  async deleteSong(songId) {
    const response = await api.delete(`/playlists/songs/${songId}`);
    return response.data;
  },

  async getAllTags() {
    const response = await api.get('/playlists/tags');
    return response.data;
  },

  async createTag(tagData) {
    const response = await api.post('/playlists/tags', tagData);
    return response.data;
  },

  async updateTag(id, tagData) {
    const response = await api.put(`/playlists/tags/${id}`, tagData);
    return response.data;
  },

  async deleteTag(id) {
    const response = await api.delete(`/playlists/tags/${id}`);
    return response.data;
  }
};

export const prizeService = {
  async getAllPrizes() {
    const response = await api.get('/prizes');
    return response.data;
  },

  async getPrizeById(id) {
    const response = await api.get(`/prizes/${id}`);
    return response.data;
  },

  async redeemPrize(prizeId) {
    const response = await api.post('/prizes/redeem', { prizeId });
    return response.data;
  },

  async getUserRedemptions() {
    const response = await api.get('/prizes/user/redemptions');
    return response.data;
  }
};

export const marshmallowService = {
  async createMarshmallow(data) {
    const response = await api.post('/marshmallows', data);
    return response.data;
  },

  async getMyMarshmallows() {
    const response = await api.get('/marshmallows/my');
    return response.data;
  },

  async bindMarshmallow(marshmallowId) {
    const response = await api.post('/marshmallows/bind', { marshmallowId });
    return response.data;
  },

  async getAllMarshmallows() {
    const response = await api.get('/marshmallows/admin');
    return response.data;
  },

  async replyMarshmallow(id, replyContent) {
    const response = await api.put(`/marshmallows/${id}/reply`, { reply_content: replyContent });
    return response.data;
  },

  async markAsRead(id) {
    const response = await api.post(`/marshmallows/${id}/read`);
    return response.data;
  },

  async deleteMarshmallows(ids) {
    const response = await api.post('/marshmallows/delete', { ids });
    return response.data;
  }
};

export const bilibiliService = {
  async getInfo() {
    // 直接从后端获取，后端已实现缓存
    const response = await api.get('/bilibili/info');
    return response.data;
  }
};

export const bilibiliBindingService = {
  /**
   * 检查用户是否有权限使用需要绑定的功能（截图、盲盒统计、礼物展示）
   * @returns {Promise<{hasAccess: boolean, reason?: string, code?: string, isAdmin?: boolean}>}
   */
  async checkFeatureAccess() {
    const response = await api.get('/bilibili-binding/check-feature-access');
    return response.data;
  },

  /**
   * 获取绑定状态
   */
  async getBindingStatus() {
    const response = await api.get('/bilibili-binding/status');
    return response.data;
  }
};

export { default as botService } from './botService';
export { default as permissionService } from './permissionService';
export { default as blindboxService } from './blindboxService';
export { default as websocketService } from './websocketService';
export { default as giftScreenshotService } from './giftScreenshotService';
